import dayjs from 'dayjs';

export const getCurrentTime = (_format = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(new Date()).format(_format);
};
